import { useState, useEffect } from 'react';
import { Multiselect, Label, Button, ComboBox } from '@teo/components';
import { useTranslation } from 'react-i18next';
import { emailRegex } from '@/constants/regex.constants';
import { parseFilter } from '@/util';

const PaginationMultiSelect = ({
  fetch,
  defaultSort = [],
  customStyles,
  render,
  keyFn,
  onChange,
  value,
  setFilter,
  filter,
  filterFn,
  ...other
}: any) => {
  const { t } = useTranslation();

  const [localFilter, setLocalFilter] = useState('');
  const myFilter = filter || localFilter;
  const setMyFilter = setFilter || setLocalFilter;

  const [debouncedFilter, setDebouncedFilter] = useState(myFilter);
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(myFilter), 250);
    return () => clearTimeout(t);
  }, [myFilter]);

  const [data, setData] = useState<any[]>(value);

  const result: any = fetch({
    offset: 0,
    count: 10,
    sort: defaultSort
      .map((sort: any) => (sort.desc ? '-' : '') + sort.id)
      .join(','),
    q: parseFilter(debouncedFilter),
  });

  useEffect(() => {
    if (result?.data) {
      let newData = (result?.data?.data as any[]).map((x) => {
        Object.assign(x, { label: render(x) });
        return x;
      });
      newData.forEach((x) => (x.key = keyFn ? keyFn(x) : x.id));
      if (filterFn) {
        newData = newData.filter((x) => filterFn(x));
      }
      setData(newData);
    }
  }, [result?.data]);

  const handleValue = (newValue: any) => {
    const prevState = value?.find(
      (el: any) => el?.key === newValue[newValue.length - 1]?.key
    );
    prevState
      ? onChange((prev: any) =>
          prev?.filter((item: any) => item?.key !== prevState?.key)
        )
      : onChange(newValue);
  };

  if (value) {
    value = value.map((value: any) =>
      Object.assign({}, value, { label: render(value) })
    );
  }

  return (
    <Multiselect
      customStyles={customStyles}
      removeButtonLabel="clear"
      toggleSelectionLabel="toggle"
      onChange={(param) => {
        setMyFilter('');
        handleValue(param);
      }}
      onCommitQuery={() => {
        setMyFilter('');
        if (data.length >= 1) {
          onChange([...value], data[0]);
        }
      }}
      onRemoved={(value) => {
        setMyFilter('');
        onChange(value);
      }}
      options={data}
      query={myFilter}
      setQuery={(query) => setMyFilter(query)}
      value={value || []}
      {...other}
    />
  );
};

export { PaginationMultiSelect };
